import { ConfigContext } from '@/context/config-context';
import getToken from '@/general/token-retriever';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import { useContext } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';
import { useTranslation } from "react-i18next";

const useAuthenticatedDelete = () => {
    const navigate = useNavigate();
    const msalContext = useMsal();
    var configContext = useContext(ConfigContext);
    const { t } = useTranslation();

    const deleteRequest = async (url: string) => {

        const token = await getToken(msalContext, configContext);
        const savedLanguage = localStorage.getItem('selectedLanguage');

        const response = await axios.delete(configContext.configBody.api.baseUrl + url, {
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Accept-Language': savedLanguage,
                'Ocp-Apim-Subscription-Key': configContext.configBody.api.apiKey,
            }
        });

        if (response.status === 401) {
            toast.error(t('unauthorizedAccess'));
            return navigate("/not-authorized");
        }

        return response.data;
    };

    return deleteRequest;
};

export default useAuthenticatedDelete;